import { IoClose } from "react-icons/io5";
import styles from "./ChatItem.module.scss";
//TODO BUG SEND MESSAGE AND NAVIGATE IN CURRENT MESSAGE ROOME
function LoadingFile({
  children,
  isSender,
  onRemove,
}) {
  return (
    <div className={`${styles.item} ${isSender == false ? styles.sender : ""}`}>
      <div className={styles.box}>
        <div className={styles.header}>
        </div>

        <div className="row">
          <div className={styles.body}>{children}


            <div className={styles.date + " mt-3"} onClick={onRemove}>
              <button className="btn-danger btn">
                <IoClose color="#fff" size={25} />
                لغو ارسال
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default LoadingFile;
